import React from "react";

function PimentitLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path fill="#FF4500" d="M16 8A8 8 0 110 8a8 8 0 0116 0z"></path>
      <path
        fill="#fff"
        d="M6.884 4.534l-2.898 6.932H2.817l2.886-6.932h1.181zM9.681 7.415a1.136 1.136 0 00-.551-.128.792.792 0 00-.668.315c-.16.207-.24.49-.24.85v2.027h-1.31V6.234h1.31v.788h.016c.208-.575.58-.863 1.12-.863.138 0 .246.017.323.05v1.206zM13.183 4.534l-2.898 6.932h-1.17l2.886-6.932h1.182z"
      ></path>
    </svg>
  );
}

export default PimentitLogo;
